export default __webpack_public_path__ + "9081355de14f9824ffa88aad04d23840.png";